import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const SOILUSEGROUP_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.SoilUseGroup.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.SoilUseGroup.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
];

export const SOILUSEGROUP_CONFIG = {
  entityName: 'SoilUseGroup',
  localizationKey: 'Planning::Entity.SoilUseGroup',
  fields: SOILUSEGROUP_FIELDS,
  permission: 'PlanningOperation.SoilUseGroups',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.OperationPlanning + MENU_NAME_SUFFIX,
};
